import styled from 'styled-components'
import {colors} from '../../../styles/theme'

export const AssetDescription = styled.p`
  margin: 0;
  padding: 0;
  color: ${colors.bksGray80};
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
`

export const ButtonBox = styled.div`
  padding-top: 48px;

  && a {
    display: inline !important;
  }
`
